<template>
    <div class="record_container">
        <header class="record_header"></header>
        <main class="record_main">
            <div class="tab_top">
                <div :class="[isActive == 'luoyan' ? 'active' : '']" @click="changeTab('luoyan')">裸眼</div>
                <div :class="[isActive == 'quguang' ? 'active' : '']" @click="changeTab('quguang')">屈光</div>
                <div :class="[isActive == 'yanzhou' ? 'active' : '']" @click="changeTab('yanzhou')">眼轴</div>
            </div>
            <div class="tab_content">
              <div v-show="isActive == 'luoyan'">
                  <p class="no_data" v-if="!tableData1.length">暂无数据</p>
                  <div class="luoyan" v-else>
                    <table class="table" cellspacing="0" cellpadding="0">
                        <thead>
                            <tr>
                                <th style="padding:0.1rem 0;width:33%;">右眼</th>
                                <th style="padding:0.1rem 0;width:33%;">左眼</th>
                                <th style="padding:0.1rem 0;width:33%;">时间</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in tableData1" :key="index">
                                <td style="padding:0.1rem 0;width:33%;" v-cloak>{{ item.rightEye }}</td>
                                <td style="padding:0.1rem 0;width:33%;" v-cloak>{{ item.leftEye }}</td>
                                <td style="padding:0.1rem 0;width:33%;" v-cloak>{{ getTime(item.testTime) }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <img class="luoyan_miaoshu" src="https://report-normal.iouou.cn/images/4a4c2ef1a480ddae7945b91c9cc91e5a.png" alt="">
                    <img src="https://report-normal.iouou.cn/images/843cd18a9d0d28643e4a68c3104e697e.jpg" alt="">
                  </div>
              </div>
              <div v-show="isActive == 'quguang'">
                <p class="no_data" v-if="!tableData2.length">暂无数据</p>
                <div class="quguang" v-else>
                    <div class="quguang_item" v-for="(item,index) in tableData2" :key="index">
                        <div v-cloak>{{ getTime(item.testTime) }}</div>
                        <table class="table" cellspacing="0" cellpadding="0">
                            <thead>
                                <tr>
                                    <th style="padding:0.1rem 0;width:25%;"></th>
                                    <th style="padding:0.1rem 0;width:25%;">球镜S</th>
                                    <th style="padding:0.1rem 0;width:25%;">柱镜C</th>
                                    <th style="padding:0.1rem 0;width:25%;">轴位A</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style="padding:0.1rem 0;width:25%;">右眼</td>
                                    <td style="padding:0.1rem 0;width:25%;" v-cloak>{{ item.rightSph }}</td>
                                    <td style="padding:0.1rem 0;width:25%;" v-cloak>{{ item.rightSe }}</td>
                                    <td style="padding:0.1rem 0;width:25%;" v-cloak>{{ item.rightAxis }}</td>
                                </tr>
                                <tr>
                                    <td style="padding:0.1rem 0;width:25%;">左眼</td>
                                    <td style="padding:0.1rem 0;width:25%;" v-cloak>{{ item.leftSph }}</td>
                                    <td style="padding:0.1rem 0;width:25%;" v-cloak>{{ item.leftSe }}</td>
                                    <td style="padding:0.1rem 0;width:25%;" v-cloak>{{ item.leftAxis }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <ul class="miaoshu">
                      <li>球镜为近视或远视度数，负值"-"为近视，正值为远视。</li>
                      <li>柱镜为散光度数。</li>
                      <li>轴位为散光方向，有散光度数才会有散光轴位。</li>
                      <li>本次验光为非睫状肌麻痹下验光进行视力筛查，结果不具有诊断意义。</li>
                    </ul>
                </div>
              </div>
              <div v-show="isActive == 'yanzhou'">
                  <p class="no_data" v-if="!tableData3.length">暂无数据</p>
                  <div class="yanzhou" v-else>
                    <table class="table" cellspacing="0" cellpadding="0">
                        <thead>
                            <tr>
                                <th style="padding:0.1rem 0;width:33%;">右眼</th>
                                <th style="padding:0.1rem 0;width:33%;">左眼</th>
                                <th style="padding:0.1rem 0;width:33%;">时间</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in tableData3" :key="index">
                                <td style="padding:0.1rem 0;width:33%;" v-cloak>{{ item.rightAxi }}</td>
                                <td style="padding:0.1rem 0;width:33%;" v-cloak>{{ item.leftAxi }}</td>
                                <td style="padding:0.1rem 0;width:33%;" v-cloak>{{ getTime(item.testTime) }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <ul class="miaoshu">
                      <li>如果眼轴长度大于24mm，临床上一般认为是近视。</li>
                      <li>如果眼轴长度小于19mm左右，临床上称作真性小眼球，容易出现继发性青光眼等并发症。</li>
                      <li>眼轴长度越大近视度数就会越高，一般眼轴长度每增加1mm，近视度数就会增加300度。</li>
                      <li>儿童出生后的眼轴长度是15.72-17mm 左右，1-5岁每年增长0.5-1mm ，1岁眼轴长度大约19mm ，5岁增长到大约22mm，7岁发展到正常接近成人24mm左右。</li>
                    </ul>
                  </div>
              </div>
            </div>
        </main>
        <div class="loading" v-if="show">
            <van-loading size="30px" vertical color="#3BD3C1">加载中...</van-loading>
        </div>
    </div>
</template>

<script>
import { getRecordApi } from "@/api/record.js";
import { getStudentId } from "@/utils/auth.js";
export default {
  data() {
    return {
      show: true,
      isActive: "luoyan",
      tableData1: [],
      tableData2: [],
      tableData3: []
    };
  },
  created() {
    this.getRecord()
  },
  methods: {
    changeTab(value) {
      this.isActive = value;
    },
    getTime(time) {
      let date = new Date(time * 1000);
      let Y = date.getFullYear();
      let M = date.getMonth() + 1;
      let D = date.getDate();
      return `${Y}-${M < 10 ? "0" + M : M}-${D < 10 ? "0" + D : D}`;
    },
    async getRecord(type) {
      await getRecordApi({
        studentId: getStudentId(),
        type: 1
      }).then(res => {
        if (res.data.data.length) {
          this.tableData1 = res.data.data;
        } else {
          this.tableData1 = [];
        }
      });
      await getRecordApi({
        studentId: getStudentId(),
        type: 2
      }).then(res => {
        if (res.data.data.length) {
          this.tableData2 = res.data.data;
        } else {
          this.tableData2 = [];
        }
      });
      await getRecordApi({
        studentId: getStudentId(),
        type: 3
      }).then(res => {
        console.log(res)
        if (res.data.data.length) {
          this.tableData3 = res.data.data;
        } else {
          this.tableData3 = [];
        }
      });
      this.show = false
    }
  },
  watch: {
    // isActive: {
    //   handler: function(newVal, oldVal) {
    //     console.log(newVal);
    //     if (newVal == "luoyan") {
    //       this.getRecord(1);
    //     }
    //     if (newVal == "quguang") {
    //       this.getRecord(2);
    //     }
    //     if (newVal == "yanzhou") {
    //       this.getRecord(3);
    //     }
    //   },
    //   immediate: true
    // }
  }
};
</script>

<style scoped>
[v-cloak] {
  display: none;
}

.loading {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: #f5f5f5;
    z-index: 99999;
}

.loading > .van-loading {
   position: absolute;
   top: 50%;
   left: 50%;
   transform: translate(-50%,-50%)
}

.record_container {
  height: 100vh;
  background-color: #f5f5f5;
  overflow: hidden;
  overflow-y: auto;
  position: relative;
}

.record_header {
  height: 1.29rem;
  padding-top: 0.01rem;
  border-radius: 0 0 0.2rem 0.2rem;
  background-color: #3bd3c1;
}

.record_main {
  position: absolute;
  top: 0.2rem;
  width: 100%;
}

.tab_top {
  height: 0.4rem;
  padding: 0 0.3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tab_top > div {
  flex: 1;
  border-right: 0.01rem solid #ffffff;
  opacity: 0.6;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.14rem;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
}

.tab_top > div:last-child {
  border: 0;
}

.tab_top > div.active {
  opacity: 1;
  font-size: 0.16rem;
  color: #ffffff;
}

.tab_content {
  width: calc(100vw - 0.2rem);
  margin: 0 auto;
  position: relative;
}

.tab_content > div {
  width: 100%;
  position: absolute;
  top: 0;
  height: calc(100vh - 0.6rem);
}

.no_data {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-family: SourceHanSansCN-Normal;
  font-size: 0.18rem;
  color: #131415;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
}

.luoyan,
.quguang,
.yanzhou {
  background-color: #ffffff;
  border-radius: 0.2rem;
  padding: 0.2rem;
}

table {
  width: 100%;
  border: 0.01rem solid #eaeaea;
  border-radius: 0.04rem;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.14rem;
  color: #131415;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
}

thead {
  background-color: #d8d8d8;
}

tbody > tr:nth-child(even) {
  background-color: rgb(241, 241, 241);
}

.quguang_item > div:first-child {
  font-family: SourceHanSansCN-Normal;
  font-size: 0.12rem;
  color: #505050;
  letter-spacing: 0;
  font-weight: 400;
  line-height: 0.12rem;
  margin-bottom: 0.1rem;
  text-indent: 0.1rem;
}

.quguang_item {
  margin-bottom: 0.15rem;
}

.quguang > .quguang_item:last-child {
  margin: 0;
}

.luoyan > img {
  width: 100%;
}

.luoyan_miaoshu {
  margin-top: 0.2rem;
}

.miaoshu {
  margin-top: 0.2rem;
}

.miaoshu > li {
  list-style-type: disc;
  margin-left: 0.2rem;
  font-family: SourceHanSansCN-Normal;
  font-size: 0.12rem;
  color: #737575;
  font-weight: 400;
}
</style>